"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var collectionsRef_1 = require("common/db/collectionsRef");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
function CBATable(props) {
    var _a;
    var ref = collectionsRef_1.CBAsRef;
    if (props.projectId) {
        ref = ref.where('projectId', '==', props.projectId);
    }
    if (props.orderId) {
        ref = ref.where('orderId', '==', props.orderId);
    }
    if (props.statuses) {
        ref = ref.where('status', 'in', props.statuses);
    }
    var snapshot = (0, firestore_1.useCollection)(ref)[0];
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t('common.CBA'));
    var dataSource = ((_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.docs) !== null && _a !== void 0 ? _a : []).map(function (s) {
        var _a;
        var data = s.data();
        return __assign(__assign({}, data), { id: s.id, projectId: (_a = s.data()) === null || _a === void 0 ? void 0 : _a.projectId });
    });
    var columns = [
        {
            name: 'projectId',
            title: t('projects.projectName'),
            getCellValue: function (r) {
                var _a;
                return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.name;
            },
        },
        {
            name: 'createdAt',
            title: t('orders.createdAt'),
            getCellValue: function (r) {
                var _a;
                return t('common.fullDateTime', { date: (_a = r.createdAt) === null || _a === void 0 ? void 0 : _a.toDate() });
            },
        },
        {
            name: 'requestedAt',
            title: t('orders.requestedAt'),
            getCellValue: function (r) {
                var _a;
                return t('common.fullDateTime', { date: (_a = r.requestedAt) === null || _a === void 0 ? void 0 : _a.toDate() });
            },
        },
        {
            name: 'requestedBy',
            title: t('orders.requestedBy'),
            getCellValue: function (r) {
                var _a, _b;
                return (_b = (_a = usersList_1.globalUsersData[r.requestedBy]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
            },
        },
        {
            name: 'initiatedBy',
            title: t('orders.initiatedBy'),
            getCellValue: function (r) {
                var _a, _b;
                return (_b = (_a = usersList_1.globalUsersData[r.initiatedBy]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
            },
        },
        {
            name: 'description',
            title: t('orders.description'),
        },
        {
            name: 'status',
            title: t('common.status'),
        },
        {
            name: 'id',
            title: t('common.actions'),
            key: 'id',
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                var projectId = dataSource.find(function (e) { return e.id === row.id; }).projectId;
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, hasProjectPermission_1.hasProjectPermission)(projectId, ['CBAView']) ? ((0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/comparative-bid-analysis/".concat(row.id), type: "primary", style: { margin: '0px 5px' } }, { children: t('common.view') })) }))) : null }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                table: 'comparative-bid-analysis',
                filter: !props.orderId,
                groups: !props.orderId,
                allowHidingColumns: false,
            }), true) })) }));
}
exports.default = CBATable;
